import axios from 'axios';

export const getTokenRequest = (accessToken: string) => axios({
    method: 'GET',
    url: `/api/v1/auth?accessToken=${accessToken}`,
});
